"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.createTheme = exports.theme = exports.getCssText = exports.keyframes = exports.globalCss = exports.css = exports.styled = void 0;
// stitches.config.ts
var react_1 = require("@stitches/react");
exports.styled = (_a = (0, react_1.createStitches)({
    theme: {
        colors: {
            gray1: "#FCFCFC",
            gray2: "#F8F8F8",
            gray3: "#F3F3F3",
            gray4: "#EDEDED",
            gray5: "#E8E8E8",
            gray6: "#E2E2E2",
            gray7: "#DBDBDB",
            gray8: "#C7C7C7",
            gray9: "#8F8F8F",
            gray10: "#858585",
            gray11: "#6F6F6F",
            gray12: "#171717",
            green1: "#FBFEFC",
            green2: "#F2FCF5",
            green3: "#E9F9EE",
            green4: "#DDF3E4",
            green5: "#CCEBD7",
            green6: "#B4DFC4",
            green7: "#92CEAC",
            green8: "#5BB98C",
            green9: "#30A46C",
            green10: "#299764",
            green11: "#18794E",
            green12: "#153226",
            green13: "#30A46C",
            yellow3: "#FFF4D5",
            yellow4: "#FFF8BB",
            yellow5: "#FEF2A4",
            yellow6: "#F9E68C",
            yellow7: "#EFD36C",
            yellow8: "#EBBC00",
            yellow9: "#F5D90A",
            yellow10: "#F7CE00",
            yellow11: "#AD5700",
            red1: "#FFFCFC",
            red2: "#FFF8F8",
            red3: "#FFEFEF",
            red4: "#FFE5E5",
            red5: "#FDD8D8",
            red6: "#F9C6C6",
            red7: "#F3AEAF",
            red8: "#EB9091",
            red9: "#E5484D",
            red10: "#DC3D43",
            red11: "#CD2B31",
            red12: "#381316",
            blue1: "#FDFDFE",
            blue2: "#F7F9FF",
            blue3: "#F0F3FF",
            blue4: "#E8EEFF",
            blue5: "#E1E7FC",
            blue6: "#CFD9FA",
            blue7: "#B5C3F5",
            blue8: "#95A7F0",
            blue9: "#4C4FF5",
            blue10: "#4649E3",
            blue11: "#4044C9",
            blue12: "#121345",
            white: "#FFFFFF",
            black: "#000000",
            overlay: "rgba(0, 0, 0, 0.56)",
            pink3: "#FEEEF8",
            pink11: "#BC328A",
            purple3: "#F9F1FE",
            purple11: "#793AAF",
            focus: "#B5C3F5",
            error: "#F3AEAF",
        },
        shape: {
            borderRadius: "6px",
        },
        shadows: {
            shadowSm: "0px 1px 2px rgba(0, 0, 0, 0.05)",
            shadowInner: "inset 0px 2px 4px rgba(0, 0, 0, 0.05)",
        },
    },
    media: {
        bp1: "(min-width: 600px)",
        bp2: "(min-width: 900px)",
        bp3: "(min-width: 1200px)",
        bp4: "(min-width: 1536px)",
    },
    utils: {
        marginX: function (value) { return ({ marginLeft: value, marginRight: value }); },
    },
}), _a.styled), exports.css = _a.css, exports.globalCss = _a.globalCss, exports.keyframes = _a.keyframes, exports.getCssText = _a.getCssText, exports.theme = _a.theme, exports.createTheme = _a.createTheme, exports.config = _a.config;
//# sourceMappingURL=stitches.config.js.map